/**
 * @since 7.1.0
 */
export interface DeleteCalendarOptions {
  /**
   * @since 7.1.0
   */
  id: string;
}
